
import {Component, Vue} from 'vue-property-decorator';
import {appName} from '@/env';
import {readLoginError, readNoServerConnection} from '@/store/main/getters';
import {dispatchLogIn} from '@/store/main/actions';
import {rules} from '@/utils';

@Component
export default class Login extends Vue {
  public email: string = '';
  public password: string = '';
  public appName = appName;
  private showPassword: boolean = false;
  private rules = rules;
  public loading: boolean = false;

  public get loginError() {
    return readLoginError(this.$store);
  }

  public get noServerConnection() {
    return readNoServerConnection(this.$store);
  }

  public async mounted() {
    if (process.env.NODE_ENV === 'development') {
      this.email = 'user_dev';
      this.password = '1nv3st1g4df_d3v';
    }
  }

  public async submit() {
    this.loading = true
    try {
      await new Promise(r => setTimeout(r, 1000))
      await dispatchLogIn(this.$store, {username: this.email, password: this.password});
    } finally {
      this.loading = false
    }

  }
}
